import React from "react";
import { PopupWidget } from "react-calendly";

const Hero: React.FC = () => {
  const calendlyURL = "https://calendly.com/unity-dev-sales";

  return (
    <div className="pt-28 sm:pt-32 pb-8 md:pb-[4em] relative flex items-center sm:min-h-[600px]">
      <div className="w-full mx-auto max-w-[940px] px-[1.5em] md:px-[2.5em]">
        <h2 className="text-white text-2xl md:text-5xl sm:leading-[1.35] md:leading-[1.4] font-light mb-0">
          Empowering the future with&nbsp;
          <span className="border-b-2 md:border-b-4 border-white">
            intelligent algorithms
          </span>
          &nbsp;and&nbsp;
          <span className="border-b-2 md:border-b-4 border-white">
            AI-driven innovation
          </span>
          &nbsp;to solve complex problems with precision and automation.
        </h2>
      </div>
      <PopupWidget
        url={calendlyURL}
        rootElement={document.getElementById("root") as HTMLElement}
        text="Explore AI Solutions with Us!"
        textColor="#ffffff"
        color="#00a2ff"
      />
      <div className="absolute top-0 left-0 w-[725px] h-[725px] bg-[#1E1B45] blur-[15.625em] rounded-[6.25em] opacity-70 translate-x-[-30%] translate-y-[-40%] pointer-events-none" />
      <div className="absolute top-0 right-0 w-[300px] h-[300px] bg-[#DF7716] blur-[9.375em] rounded-[6.25em] opacity-25 translate-x-[65%] translate-y-[-65%] pointer-events-none" />
    </div>
  );
};
// We harness the power of cutting-edge code and stunning design to solve complex challenges with precision and innovation.

export default Hero;
